module.exports = __webpack_public_path__ + "img/Kanban.64014859.svg";